import Login from './Login';
import Logout from './Logout';

export const routes = [
	{
		path: '/login',
		name: 'login',
		component: Login
	},
	{
		path: '/logout',
		name: 'logout',
		component: Logout,
		props: { isLogout: true }
	}
];

export default routes;
